import { useTranslation } from 'react-i18next';
import type { EnrichmentStats } from './queries';
import { Stat, StatStrip } from '../../components/ui/stat';

/** Six enrichment counters. */
export function StatsStrip({ stats }: { stats: EnrichmentStats | undefined }) {
  const { t } = useTranslation(['enrichment', 'common']);
  return (
    <StatStrip>
      <Stat label={t('stats.orgsMissingIco')} value={stats?.orgsMissingIco} />
      <Stat label={t('stats.pending')} value={stats?.pending} />
      <Stat label={t('stats.autoAccepted')} value={stats?.autoAccepted} />
      <Stat label={t('stats.accepted')} value={stats?.accepted} />
      <Stat label={t('stats.rejected')} value={stats?.rejected} />
      <Stat label={t('stats.noMatch')} value={stats?.noMatch} />
    </StatStrip>
  );
}
